var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('traveler-data',{attrs:{"agency-code":_vm.agencyCode}})],1)}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }